import React from 'react';
import PropTypes from 'prop-types';
import X from 'wix-ui-icons-common/X';
import PrettyIcon from '../PrettyIcon/PrettyIcon';
import styles from './InformativeModalLayout.scss';

import { Text, Heading } from 'wix-style-react';

export default function InformativeModalLayout({
  title,
  content,
  appendix,
  illustration,
  footer,
  onRequestClose,
  dataHook,
  shouldNOTRenderX,
}) {
  return (
    <div className={styles.wrapper} data-hook={dataHook}>
      {shouldNOTRenderX ? null : (
        <PrettyIcon
          className={styles.closeButton}
          data-hook="informative-modal-layout-close-button"
          onClick={onRequestClose}
        >
          <X />
        </PrettyIcon>
      )}
      <div className={styles.horizontal}>
        <div className={styles.illustration}>{illustration}</div>
        <div className={styles.main}>
          <Heading appearance="H2" dataHook="informative-modal-layout-title" style={{ fontSize: 24 }}>
            {title}
          </Heading>
          <Text
            size="medium"
            weight="normal"
            tagName="div"
            className={styles.content}
            data-hook="informative-modal-layout-content"
          >
            {content}
          </Text>
          <Text
            size="small"
            secondary
            weight="normal"
            tagName="div"
            className={styles.content}
            data-hook="informative-modal-layout-appendix"
          >
            {appendix}
          </Text>
        </div>
      </div>
      {footer}
    </div>
  );
}

InformativeModalLayout.displayName = 'InformativeModalLayout';
InformativeModalLayout.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  appendix: PropTypes.string,
  footer: PropTypes.node,
  illustration: PropTypes.node,
  onRequestClose: PropTypes.func,
  dataHook: PropTypes.string,
  shouldNOTRenderX: PropTypes.bool,
};
